import { render, staticRenderFns } from "./DynamicComponent.vue?vue&type=template&id=00326374&scoped=true"
import script from "./DynamicComponent.vue?vue&type=script&lang=js"
export * from "./DynamicComponent.vue?vue&type=script&lang=js"
import style0 from "./DynamicComponent.vue?vue&type=style&index=0&id=00326374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00326374",
  null
  
)

export default component.exports